import { createAction } from 'redux-actions';
import Types from './types';

export const newPartnerRequest = createAction(Types.NEW_PARTNER_REQUEST);
export const newPartnerFulfilled = createAction(Types.NEW_PARTNER_FULFILLED);
export const newPartnerRejected = createAction(Types.NEW_PARTNER_REJECTED);

export const getCustomStateRequest = createAction(
  Types.GET_CUSTOM_STATE_REQUEST
);
export const getCustomStateFulfilled = createAction(
  Types.GET_CUSTOM_STATE_FULFILLED
);
export const getCustomStateRejected = createAction(
  Types.GET_CUSTOM_STATE_REJECTED
);

export const saveCustomRequest = createAction(Types.SAVE_CUSTOM_REQUEST);
export const saveCustomFulfilled = createAction(Types.SAVE_CUSTOM_FULFILLED);
export const saveCustomRejected = createAction(Types.SAVE_CUSTOM_REJECTED);

export const removeImageCustomRequest = createAction(
  Types.REMOVE_IMAGE_REQUEST
);
export const removeImageCustomFulfilled = createAction(
  Types.REMOVE_IMAGE_FULFILLED
);
export const removeImageCustomRejected = createAction(
  Types.REMOVE_IMAGE_REJECTED
);

export const publishCustomRequest = createAction(Types.PUBLISH_CUSTOM_REQUEST);
export const publishCustomFulfilled = createAction(
  Types.PUBLISH_CUSTOM_FULFILLED
);
export const publishCustomRejected = createAction(
  Types.PUBLISH_CUSTOM_REJECTED
);

export const editCustomRequest = createAction(Types.EDIT_CUSTOM_REQUEST);
export const editCustomFulfilled = createAction(Types.EDIT_CUSTOM_FULFILLED);
export const editCustomRejected = createAction(Types.EDIT_CUSTOM_REJECTED);

export const deleteCustomRequest = createAction(Types.DELETE_CUSTOM_REQUEST);
export const deleteCustomFulfilled = createAction(
  Types.DELETE_CUSTOM_FULFILLED
);
export const deleteCustomRejected = createAction(Types.DELETE_CUSTOM_REJECTED);

export const LDAPTestRequest = createAction(Types.LDAP_TEST_REQUEST);
export const LDAPTestFulfilled = createAction(Types.LDAP_TEST_FULFILLED);
export const LDAPTestRejected = createAction(Types.LDAP_TEST_REJECTED);

export const deletePartnerRequest = createAction(Types.DELETE_PARTNER_REQUEST);
export const deletePartnerFulfilled = createAction(
  Types.DELETE_PARTNER_FULFILLED
);
export const deletePartnerRejected = createAction(
  Types.DELETE_PARTNER_REJECTED
);

export const editPartnerRequest = createAction(Types.EDIT_PARTNER_REQUEST);
export const editPartnerFulfilled = createAction(Types.EDIT_PARTNER_FULFILLED);
export const editPartnerRejected = createAction(Types.EDIT_PARTNER_REJECTED);

export const getPartnerRequest = createAction(Types.GET_PARTNER_REQUEST);
export const getPartnerFulfilled = createAction(Types.GET_PARTNER_FULFILLED);
export const getPartnerRejected = createAction(Types.GET_PARTNER_REJECTED);

export const getAllPartnersRequest = createAction(
  Types.GET_ALL_PARTNERS_REQUEST
);
export const getAllPartnersFulfilled = createAction(
  Types.GET_ALL_PARTNERS_FULFILLED
);
export const getAllPartnersRejected = createAction(
  Types.GET_ALL_PARTNERS_REJECTED
);

export const getAllPartnersOperatorRequest = createAction(
  Types.GET_ALL_PARTNERS_OPERATOR_REQUEST
);
export const getAllPartnersOperatorFulfilled = createAction(
  Types.GET_ALL_PARTNERS_OPERATOR_FULFILLED
);
export const getAllPartnersOperatorRejected = createAction(
  Types.GET_ALL_PARTNERS_OPERATOR_REJECTED
);

export const toggleBlockPartnerRequest = createAction(
  Types.TOGGLE_BLOCK_PARTNER_REQUEST
);
export const toggleBlockPartnerFulfilled = createAction(
  Types.TOGGLE_BLOCK_PARTNER_FULFILLED
);
export const toggleBlockPartnerRejected = createAction(
  Types.TOGGLE_BLOCK_PARTNER_REJECTED
);

export const setSelectedCompany = createAction(Types.SET_SELECTED_COMPANY);
export const setSelectedPartner = createAction(Types.SET_SELECTED_PARTNER);

export const getAllPartnerServersRequest = createAction(
  Types.GET_ALL_PARTNER_SERVERS_REQUEST
);
export const getAllPartnerServersFulfilled = createAction(
  Types.GET_ALL_PARTNER_SERVERS_FULFILLED
);
export const getAllPartnerServersRejected = createAction(
  Types.GET_ALL_PARTNER_SERVERS_REJECTED
);

export const startPartnerServersRequest = createAction(
  Types.START_PARTNER_SERVERS_REQUEST
);
export const startPartnerServersFulfilled = createAction(
  Types.START_PARTNER_SERVERS_FULFILLED
);
export const startPartnerServersRejected = createAction(
  Types.START_PARTNER_SERVERS_REJECTED
);

export const stopPartnerServersRequest = createAction(
  Types.STOP_PARTNER_SERVERS_REQUEST
);
export const stopPartnerServersFulfilled = createAction(
  Types.STOP_PARTNER_SERVERS_FULFILLED
);
export const stopPartnerServersRejected = createAction(
  Types.STOP_PARTNER_SERVERS_REJECTED
);

export const publishPartnerServersRequest = createAction(
  Types.PUBLISH_PARTNER_SERVERS_REQUEST
);
export const publishPartnerServersFulfilled = createAction(
  Types.PUBLISH_PARTNER_SERVERS_FULFILLED
);
export const publishPartnerServersRejected = createAction(
  Types.PUBLISH_PARTNER_SERVERS_REJECTED
);

export const clonePartnerRequest = createAction(Types.CLONE_PARTNER_REQUEST);
export const clonePartnerFulfilled = createAction(
  Types.CLONE_PARTNER_FULFILLED
);
export const clonePartnerRejected = createAction(Types.CLONE_PARTNER_REJECTED);

export const changeAdPasswordRequest = createAction(
  Types.CHANGE_AD_PASSWORD_REQUEST
);
export const changeAdPasswordFulfilled = createAction(
  Types.CHANGE_AD_PASSWORD_FULFILLED
);
export const changeAdPasswordRejected = createAction(
  Types.CHANGE_AD_PASSWORD_REJECTED
);

export const getLDAPTypeReportFulfilled = createAction(
  Types.GET_LDAP_TYPE_REPORT_FULFILLED
);
export const getLDAPTypeReportRejected = createAction(
  Types.GET_LDAP_TYPE_REPORT_REJECTED
);
export const getLDAPTypeReportRequest = createAction(
  Types.GET_LDAP_TYPE_REPORT_REQUEST
);

export const getSSOReportFulfilled = createAction(
  Types.GET_SSO_REPORT_FULFILLED
);
export const getSSOReportRejected = createAction(Types.GET_SSO_REPORT_REJECTED);
export const getSSOReportRequest = createAction(Types.GET_SSO_REPORT_REQUEST);

export const getNewFrontReportFulfilled = createAction(
  Types.GET_NEW_FRONT_REPORT_FULFILLED
);
export const getNewFrontReportRejected = createAction(
  Types.GET_NEW_FRONT_REPORT_REJECTED
);
export const getNewFrontReportRequest = createAction(
  Types.GET_NEW_FRONT_REPORT_REQUEST
);

export const getPartnerProviderTypeReportFulfilled = createAction(
  Types.GET_PARTNER_PROVIDER_TYPE_REPORT_FULFILLED
);
export const getPartnerProviderTypeReportRejected = createAction(
  Types.GET_PARTNER_PROVIDER_TYPE_REPORT_REJECTED
);
export const getPartnerProviderTypeReportRequest = createAction(
  Types.GET_PARTNER_PROVIDER_TYPE_REPORT_REQUEST
);

export const exportPartnerSummaryRequest = createAction(
  Types.EXPORT_PARTNER_SUMMARY_REQUEST
);
export const exportPartnerSummaryFulfilled = createAction(
  Types.EXPORT_PARTNER_SUMMARY_FULFILLED
);
export const exportPartnerSummaryRejected = createAction(
  Types.EXPORT_PARTNER_SUMMARY_REJECTED
);

export const publishImagePartnerRequest = createAction(
  Types.PUBLISH_IMAGE_PARTNER_REQUEST
);
export const publishImagePartnerFulfilled = createAction(
  Types.PUBLISH_IMAGE_PARTNER_FULFILLED
);
export const publishImagePartnerRejected = createAction(
  Types.PUBLISH_IMAGE_PARTNER_REJECTED
);

export const blockServerPartnerActionsRequest = createAction(
  Types.BLOCK_SERVER_PARTNER_ACTIONS_REQUEST
);
export const blockServerPartnerActionsFulfilled = createAction(
  Types.BLOCK_SERVER_PARTNER_ACTIONS_FULFILLED
);
export const blockServerPartnerActionsRejected = createAction(
  Types.BLOCK_SERVER_PARTNER_ACTIONS_REJECTED
);

export const unblockServerPartnerActionsRequest = createAction(
  Types.UNBLOCK_SERVER_PARTNER_ACTIONS_REQUEST
);
export const unblockServerPartnerActionsFulfilled = createAction(
  Types.UNBLOCK_SERVER_PARTNER_ACTIONS_FULFILLED
);
export const unblockServerPartnerActionsRejected = createAction(
  Types.UNBLOCK_SERVER_PARTNER_ACTIONS_REJECTED
);

export const getInstancesByUsageRequest = createAction(
  Types.GET_INSTANCES_BY_USAGE_REQUEST
);
export const getInstancesByUsageFulfilled = createAction(
  Types.GET_INSTANCES_BY_USAGE_FULFILLED
);
export const getInstancesByUsageRejected = createAction(
  Types.GET_INSTANCES_BY_USAGE_REJECTED
);
